import {createRouter,createWebHistory} from 'vue-router'
import LoginView from './views/LoginView.vue'
import DashboardView from './views/DashboardView.vue'
import ResourceView from './views/ResourceView.vue'
import GroupView from './views/GroupView.vue'
import UserView from './views/UserView.vue'
import SettingsView from './views/SettingsView.vue'
import SetupWizardView from './views/SetupWizardView.vue'
import CertificateView from './views/CertificateView.vue'
import TopologyView from './views/TopologyView.vue'
import InboundView from './views/InboundView.vue'
import ClientProfilesView from './views/ClientProfilesView.vue'
import SecretView from './views/SecretView.vue'
import NodeConfigView from './views/NodeConfigView.vue'
import NodeView from './views/NodeView.vue'

const router=createRouter({history:createWebHistory(),routes:[
 {path:'/login',component:LoginView,meta:{public:true}},
 {path:'/',component:DashboardView},
 {path:'/setup',component:SetupWizardView},
 {path:'/inbounds',component:InboundView},
 {path:'/topology',component:TopologyView},
 {path:'/client-profiles',component:ClientProfilesView},
 {path:'/node-configs',component:NodeConfigView},
 {path:'/groups',component:GroupView},
 {path:'/users',component:UserView},
 {path:'/certificates',component:CertificateView},
 {path:'/secrets',component:SecretView},
 {path:'/rule-sets',component:ResourceView,props:{kind:'rule-set-versions'}},
 {path:'/nodes',component:NodeView},
 {path:'/deployments',component:ResourceView,props:{kind:'deployments'}},
 {path:'/health',component:ResourceView,props:{kind:'health'}},
 {path:'/audit',component:ResourceView,props:{kind:'audit-logs'}},
 {path:'/settings',component:SettingsView},
]})
router.beforeEach(to=>{if(!to.meta.public&&!localStorage.getItem('autovpn_authenticated'))return '/login';if(to.path==='/login'&&localStorage.getItem('autovpn_authenticated'))return '/';})
export default router